import * as React from 'react';
import classnames from 'classnames';
import { useEcommFacetContext } from '../../../context/EcommFacetContext.js';
import { ProductStockIndicator } from '../../StockIndicator/ProductStockIndicator.js';

const SingleFacetTerm = ({ showStockIndicator =true , className  })=>{
    const { facetPickerConfig: { activeParentFacet  } ,  } = useEcommFacetContext();
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('single-facet-term', className)
    }, activeParentFacet && /*#__PURE__*/ React.createElement("div", null, activeParentFacet.facetTerm), showStockIndicator && /*#__PURE__*/ React.createElement(ProductStockIndicator, null));
};

export { SingleFacetTerm };
//# sourceMappingURL=SingleFacetTerm.js.map
